import { defaultCard } from 'types/deck'

import { DeckLeglaity, LegalityChecker } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckPauperEDHLegality: LegalityChecker = (deck: DeckLeglaity) => {
  const commander = deck.commanders[0] || defaultCard

  // prettier-ignore
  if (!commander.isPDHCommander) deck.addCardError(ERRORS.VALID_PAUPER_COMMANDER, commander)

  deck.checkHasCommander()
  deck.checkCanBeCommander()
  deck.checkMaximumCommanders()
  deck.checkPartners()

  const fullDeck = [...deck.mainboard, ...deck.commanders]

  for (const card of deck.mainboard) {
    // Don't check this on the command zone since some commanders are now `not_legal` as their PDH legality
    deck.checkCardLegality(card)
  }

  for (const card of fullDeck) {
    if (deck.commanders.length) deck.checkCardColorIdentAgainstCommanders(card)

    deck.checkCardQuantity(card, 1)
  }

  if (deck.deckSize !== 100) deck.addError(ERRORS.COMMANDER_SIZE)
}

export default CheckPauperEDHLegality
